"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TicketMessage = require("./TicketMessage.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WatchMessagePaid = function WatchMessagePaid() {
  return /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicket, {
    id: "popup-ticket"
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTwoCol, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColRight, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "Have a ticket?"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "Please enter your email associated with the ticket order below. If you're not sure, please check an email from the event org team containing direct access link and other useful instructions."), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketForm, {
    action: "/live",
    method: "get",
    target: "_blank",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketField, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketInput, {
    type: "email",
    name: "email",
    placeholder: "Your email"
  }), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketSubmitButton, {
    type: "submit"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Unlock"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketArrowSvg, null, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "img/sprite.svg#icon-arrow-right"
  }))))))));
};

var _default = WatchMessagePaid;
exports.default = _default;